import React, { useEffect } from 'react';

import { Footer } from '../../../common/footer/footer';

import Sidebar from "../sidebar/sidebar.js";

export const CustomerAskTheExpertJsx = (props) => {
  const {
    categoryData,
    formData,
    onInputChange,
    onTouchHandler,
    onSubmitButtonClick,
    checkedItems,
    handleChange,
    permissions,
    editOn,
    toggleNewPermissionInput,
    showNewPermissionInput,
    newPermission,
    handleNewPermissionSubmit,
  } = props;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="entiredashboard admindashboard py-5 bg-light">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-lg-3 col-sm-12 mb-4">
              <div className="dashboardleftpanel bg-white shadow rounded p-3">
                <Sidebar />
              </div>
            </div>

            {/* Main Content */}
            <div className="col-lg-9 col-sm-12">
              <div className="dashboardrightpanel bg-white shadow rounded p-4">
                <h2 className="text-primary mb-4">Submit Modules</h2>

                {/* Form Area */}
                <div className="mb-5">
                  <div className="mb-3">
                    <label className="form-label fw-bold">Module Name *</label>
                    <input
                      className="form-control"
                      placeholder="Enter Module Name"
                      name="name"
                      onChange={onInputChange}
                      onBlur={onTouchHandler}
                      value={formData.name}
                    />
                  </div>

                  {/* Permissions List */}
                  <div className="mb-4">
                    <label className="form-label fw-bold">Select Permissions</label>
                    <div className="row">
                      {permissions?.map((role) => {
                        const isChecked = checkedItems.some(item => item.name === role.name);
                        return (
                          <div className="col-md-6 mb-2" key={role.name}>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={role.name}
                                name={role.name}
                                value={role.name}
                                checked={isChecked}
                                disabled={!formData.name}
                                onChange={(e) => handleChange({ modulePermissionId: role.name }, e.target.checked)}
                              />
                              <label className="form-check-label" htmlFor={role.name}>
                                {role.name}
                              </label>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Add New Permission */}
                  <div className="mb-3">
                    <button
                      className="btn btn-outline-secondary"
                      disabled={!formData.name}
                      onClick={toggleNewPermissionInput}
                    >
                      Add New Permission
                    </button>
                  </div>

                  {showNewPermissionInput && (
                    <div className="mb-4">
                      <input
                        type="text"
                        className="form-control mb-2"
                        placeholder="Enter Permission Name"
                        name="newPermission"
                        value={newPermission}
                        onChange={onInputChange}
                      />
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleNewPermissionSubmit}
                      >
                        Submit New Permission
                      </button>
                    </div>
                  )}

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={!formData.name}
                    onClick={onSubmitButtonClick}
                  >
                    Submit
                  </button>
                </div>

                {/* Module Table (only shown when not editing) */}
                {!editOn && (
                  <div className="mt-5">
                    <h4 className="mb-3">Existing Modules</h4>
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped">
                        <thead className="table-primary">
                          <tr>
                            <th>Name</th>
                          </tr>
                        </thead>
                        <tbody>
                          {categoryData?.map((item, i) => (
                            <tr key={i}>
                              <td>{item.moduleName}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default CustomerAskTheExpertJsx;
